import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GroupDescriptor, DataResult, process, State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ApiService } from '../../../../services/api/api.service';
import { ConfirmationService, DialogService } from 'primeng/api';
import { NbToastrService } from '@nebular/theme';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { Permissions } from '../../../../config/AppEnums';
import { ActionDialogComponent } from '../../../shared/components/action-dialog/action-dialog.component';

@Component({
  selector: 'app-item-deliveries',
  templateUrl: './item-deliveries.component.html',
  styleUrls: ['./item-deliveries.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ItemDeliveriesComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService,
    private messageService?: NbToastrService, private authService?: IdentityAuthService,
    public dialogService?: DialogService) { }
  public gridView: GridDataResult;
  public loading: boolean;
  public outstandingExpanded: boolean;
  public animationsActive: boolean = false;
  public expandedDetailKeys: any[] = [1];
  protected _entityId: any;
  public tableData: any = [];
  public deliveries: any = [];
  public itemsDeliveryRequired: any;
  public state: any;
  public parent: any;
  public calcedOutstandingItemsGrid: any;
  public calcedOutstandingItems: any;
  public grouping: GroupDescriptor[] = [{ field: 'po', }];
  public defaultFilters: CompositeFilterDescriptor = { filters: new Array<FilterDescriptor>(), logic: 'and' };
  public get entityId() { return this._entityId };
  public canEditDelivery: boolean = false;
  public canReceiveDelivery: boolean = false;
  public get getCanEditDelivery() {
    return this.authService && this.authService.hasAnyPermissions(Permissions.StockRequisition, Permissions.ProcurementAdmin, Permissions.SuperAdmin);
  }
  public get getCanReceiveDelivery() {
    return (this.authService.userProfile && this.itemsDeliveryRequired && this.itemsDeliveryRequired.length > 0 && this.itemsDeliveryRequired[0].createdByUserId == this.authService.userProfile.sub) || this.authService.hasAnyPermissions(Permissions.ProcurementAdmin, Permissions.SuperAdmin);
  }
  public set entityId(value) {
    this._entityId = value;
    this.loadEntity();
  }
  ngOnInit() {
    var self = this;
    var defaultState = {
      skip: 0,
      filter: this.defaultFilters,
      group: [{ field: 'po' }]
    };

    this.state = defaultState;

    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }

    this.authService.permissionsChangedObserver.subscribe(o => {

      this.canEditDelivery = this.getCanEditDelivery;
      this.canReceiveDelivery = this.getCanReceiveDelivery;
    });

  }

  public calcOutstandingItems() {
  console.log('calc')
    if (!this.itemsDeliveryRequired)
      this.calcedOutstandingItems = [];
    else {
      this.itemsDeliveryRequired.forEach(o => {
        o.outstandingQty = o.qty;
        var outForDeliveryQuantity = 0;
        this.deliveries.forEach(del => {
          var deliveriesForItem = [];

          del.itemsDeliveryRequiredGrid.data.forEach(grp => {
            deliveriesForItem = grp.items.filter(filt => {
              return filt.requisitionItemId == o.id && filt.includeInDelivery == true
            });
            deliveriesForItem.forEach(z => {
              outForDeliveryQuantity += z.deliveryQuantity == '' ? 0 : parseInt(z.deliveryQuantity)
            });
          })
        })
        o.outstandingQty = o.qty - outForDeliveryQuantity
      })
    }
    this.calcedOutstandingItems = this.itemsDeliveryRequired;
  }

  public filterClientSide(state) {
    this.state = state;
    console.log('filt')
    this.gridView = process(this.tableData, state);
  }
  public dataStateChange(state: DataStateChangeEvent): void {

    console.log('state')
    this.state = state;
    this.filterClientSide(this.state);

  }
  public itemIncludedInDelivery(dataItem: any, index: number): boolean {
    return dataItem && dataItem.includeInDelivery;
  }
  public expandItemIncludedInDelivery({ dataItem, index }: any): boolean {
    return dataItem && dataItem.includeInDelivery;
  }
  public getOutstanding(rowData) {
    console.log('out')
    var filt = this.calcedOutstandingItems.filter(o => { return o.id == rowData.id });
    if (filt.length > 0)
      return filt[0].outstandingQty;
    else return 0;
  }
  public addDelivery() {
    this.outstandingExpanded = false;
    this.deliveries.forEach(del => {
      del.expanded = false;
    })
    var delivery: any = {
      expanded: true,
      deliveryDate: new Date(),
      itemsDeliveryRequired: []
    };
    this.calcedOutstandingItems.forEach(o => {
      var copy: any = {};
      Object.assign(copy, o);
      copy.deliveryQuantity = copy.outstandingQty;
      copy.includeInDelivery = copy.deliveryQuantity > 0;
      copy.requisitionItemId = copy.id;
      copy.id = null;

      delivery.itemsDeliveryRequired.push(copy)
      delivery.itemsDeliveryRequiredGrid = process(delivery.itemsDeliveryRequired, { group: this.grouping })
    })
    this.deliveries.push(delivery);
    this.calcOutstandingItems();
  }

  public removeDelivery(delivery) {
    this.confirmationService.confirm({
      message: 'Are you sure that you would like to remove this delivery?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deliveries.splice(this.deliveries.indexOf(delivery), 1);
        this.messageService.info('Action', 'Sucessfully removed');
        this.calcOutstandingItems();
      },
      reject: () => {

      }
    });
  }

  public loadEntity() {
    var self = this;
    this.loading = true;
    this.canEditDelivery = this.getCanEditDelivery;
    this.canReceiveDelivery = this.getCanReceiveDelivery;
    this.apiService.get('/api/requisition/deliveryRequired/' + this.parent.parent.currentRouteParams.id_1)
      .subscribe(o => {
        this.itemsDeliveryRequired = o;
        this.calcOutstandingItems();
        this.calcedOutstandingItemsGrid = process(this.calcedOutstandingItems, { group: this.grouping })
        this.loadDeliveries();

        this.canEditDelivery = this.getCanEditDelivery;
        this.canReceiveDelivery = this.getCanReceiveDelivery;
        self.parent.buildMenus(this.calcedOutstandingItems, this.parent.parent.currentRouteParams.id_1 == "00000000-0000-0000-0000-000000000000", 6, self)
      }, err => {
        this.loading = false;
      })


  }
  public loadDeliveries() {
    var self = this;
    this.apiService.get('/api/requisition/deliveries/' + this.parent.parent.currentRouteParams.id_1)
      .subscribe(o => {
        o.forEach(i => {
          i.deliveryDate = new Date(i.deliveryDate)
          i.receivedDate = i.receivedDate ? new Date(i.receivedDate) : null;
          i.deliveryReceived = i.receivedDate != null;
          var itemsDeliveryRequired = [];
          this.calcedOutstandingItems.forEach(z => {
            var copy: any = {};
            Object.assign(copy, z);
            copy.deliveryQuantity = copy.outstandingQty;
            copy.includeInDelivery = copy.deliveryQuantity > 0;
            copy.requisitionItemId = copy.id;
            copy.includeInDelivery = false;

            var existItem = i.requisitionDeliveryItems.filter(q => { return q.requisitionItemId == z.id });
            if (existItem.length > 0) {
              copy.id = existItem[0].id
              copy.deliveryQuantity = existItem[0].deliveryQuantity;
              //copy.deliveryReceivedOn = existItem[0].deliveryReceivedOn ? new Date(existItem[0].deliveryReceivedOn) : existItem[0].deliveryReceivedOn;
              //copy.deliveryReceivedBy = existItem[0].deliveryReceivedBy;
              copy.includeInDelivery = true;
              copy.receivedQuantity = existItem[0].receivedQuantity;
            }

            itemsDeliveryRequired.push(copy)
          })

          i.itemsDeliveryRequired = itemsDeliveryRequired
          i.itemsDeliveryRequiredGrid = process(itemsDeliveryRequired, { group: this.grouping })
        })
        this.deliveries = o;

        this.filterClientSide(this.state);
        this.calcOutstandingItems();
        this.loading = false;
        if (this.deliveries.length == 0)
          this.outstandingExpanded = true;
      }, err => {
        this.loading = false;
      })
  }

  public validateRequiredFields() {
    var allValid = true;
    var self = this;

    this.deliveries.forEach(del => {
      del.deliveryDateRequired = typeof del.deliveryDate == 'undefined' || del.deliveryDate == "";
      del.sivNumberRequired = typeof del.sivNumber == 'undefined' || del.sivNumber == "";
      del.receivedDateRequired = del.deliveryReceived && (typeof del.receivedDate == 'undefined' || del.receivedDate == "");
      del.itemsDeliveryRequiredGrid.data.forEach(grp => {
        grp.items.forEach(item => {
          item.deliveryQuantityRequired = item.includeInDelivery && (typeof item.deliveryQuantity == 'undefined' || item.deliveryQuantity == "");
          item.receivedQuantityRequired = item.includeInDelivery && del.deliveryReceived && (typeof item.receivedQuantity == 'undefined' || item.receivedQuantity == "")
          if (item.deliveryQuantityRequired || item.receivedQuantityRequired)
            allValid = false;
        })
      })
      if (del.deliveryDateRequired || del.sivNumberRequired || del.receivedDateRequired)
        allValid = false;


    })
    self.animationsActive = true;
    setTimeout(function () {
      self.animationsActive = false;
    }, 10000)
    return allValid;
  }

  public save() {
    if (!this.validateRequiredFields()) {
      const ref = this.dialogService.open(ActionDialogComponent, {
        data: {
          buttonActions: [
            {
              iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                ref.close();
              }
            }
          ],
          message: `Validations not passed - please review the data before saving again`,
        },
        header: 'Could not save',
        width: '50%'
      });
      return;
    }
    this.loading = true;
    this.deliveries.forEach(o => {
      if (!o.deliveryReceived) o.receivedDate = null;

      o.requisitionDeliveryItems = new Array();
      o.itemsDeliveryRequiredGrid.data.forEach(q => {
        q.items.forEach(item => {
          o.requisitionDeliveryItems.push(item);
        })
      })
    })
    this.apiService.post('/api/requisition/saveDeliveries/' + this.parent.parent.currentRouteParams.id_1, this.deliveries)
      .subscribe(o => {
        this.loading = false;
        this.messageService.success('Action', 'Sucessfully saved');
        this.loadEntity();
        this.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
      }, err => {
        this.loading = false;
        this.messageService.success('Action', 'Could not save');
      })
  }

  public cancel() {
    if (this.parent && this.parent.selectedItem)
      this.parent.selectedItem = null;
    if (this.parent && this.parent.closeBlade)
      this.parent.closeBlade();
  }

  public deliveryReceived(delivery) {
    delivery.receivedDate = new Date();
    delivery.itemsDeliveryRequiredGrid.data.forEach(grp => {
      grp.items.filter(o => { return o.includeInDelivery == true })
        .forEach(o => {
          o.receivedQuantity = delivery.deliveryReceived ? o.deliveryQuantity : null
        })
    })

  }
}
